export default __webpack_public_path__ + "static/media/DC Kullaflyg logo.a1c05a4c.jpg";